import React from 'react';
import {SVGProps} from '~/src/components/svg/SVGProps';

const ThumbsUp = ({title, primaryClassName, secondaryClassName, tertiaryClassName}: SVGProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        {title && <title>{title}</title>}
        <path className={primaryClassName} d="M13.5 12.31L17.04 7H20.34l.87-2h-5.25l-4.46 6.7V17h2v-4.69z" />
        <path className={secondaryClassName} d="M19 10l1.31-3h-2.15L16 12h6.5v4.73A2.28 2.28 0 0 1 20.16 19H11.5v2h8.66a4.26 4.26 0 0 0 4.34-4.26V10z" />
        <path className={tertiaryClassName} d="M9.96 19v-6.3h-2V21h3.54v-2H9.96z" />
    </svg>
);

export default ThumbsUp;
